// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareOutlinedSvg from "@fishx/icons-svg/es/asn/UpSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var UpSquareOutlined = function UpSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareOutlinedSvg
  }));
};

UpSquareOutlined.displayName = 'UpSquareOutlined';
export default React.forwardRef(UpSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpSquareOutlined.js
// module id = 4323
// module chunks = 0